import axios from "axios";

// Global Variables
import { ApiReqBaseUrl } from "../assets/GlobalVariables";
import { round2 } from "../contexts/AppContext";

// --- Functions

// Get currency - Incase changing the dropdown
const getCurrency = async (data) => {
  // Create API request for currency Calculator
  try {
    const res = await axios.post(`${ApiReqBaseUrl}/change`, data);

    return res.data;
  } catch (err) {
    console.log({ err });
  }
};

// Get currency - Incase a page load
const convertPrice = (price) => {
  try {
    // Get from local storage or use default ILS
    if (!price || price === "") {
      return "0₪";
    }
    const rate = localStorage.getItem("currentRate");
    const currencyInfo = localStorage.getItem("default-currency")
      ? localStorage.getItem("default-currency")
      : JSON.stringify({ symbol: "₪" });

    if (rate && rate !== "undefined" && currencyInfo) {
      return `${parseNumber(parseFloat(price) * parseFloat(rate))}${
        JSON.parse(currencyInfo).symbol
      }`;
    } else {
      if (currencyInfo) {
        return `${parseNumber(price)}${JSON.parse(currencyInfo).symbol}`;
      } else {
        return `${parseNumber(price)}₪`;
      }
    }
  } catch (err) {
    console.log({ err });
    const num = Number(price);
    return Number.isFinite(num) ? `${parseNumber(num)}₪` : "0₪";
  }
};

/**
 * Agent wallet SSOT (/getBasicFinancials, `/availableOrdersCommission`, history/future lists):
 * amounts are authoritative ILS ledger values. Unlike `convertPrice`, never multiplies by
 * `currentRate` (catalogue display FX) — that caused local drift (~×rate) vs production when
 * a non-default rate lingered in localStorage.
 */
const formatAgentWalletAmountIls = (price) => {
  try {
    if (price === null || price === undefined || price === "") {
      return "0₪";
    }
    const num = Number(price);
    if (!Number.isFinite(num)) {
      return "0₪";
    }
    return `${parseNumber(num)}₪`;
  } catch {
    const num = Number(price);
    return Number.isFinite(num) ? `${parseNumber(num)}₪` : "0₪";
  }
};

/** Snapshot of catalogue FX state (for WALLET_AMOUNT_SOURCE_TRACE only). */
export function readCatalogDisplayFxSnapshotForTrace() {
  try {
    if (typeof localStorage === "undefined") {
      return { rate: null, currencyInfoText: null };
    }
    const rateRaw = localStorage.getItem("currentRate");
    const currencyRaw = localStorage.getItem("default-currency");
    return {
      rate: rateRaw && rateRaw !== "undefined" ? rateRaw.trim() || null : null,
      currencyInfoText:
        currencyRaw && currencyRaw !== "undefined" ? currencyRaw.trim() || null : null,
    };
  } catch {
    return { rate: null, currencyInfoText: null };
  }
}

const getCurrencyRate = async (currencyCode) => {
  // Create API request for getting Currency Rate
  try {
    const res = await axios.post(`${ApiReqBaseUrl}/getRate`, currencyCode);

    return res.data;
  } catch (err) {
    console.log({ err });
  }
};

export function parseNumber(num) {
  if (typeof num !== "number" && isNaN(parseFloat(num))) {
    console.error(`${num} is not a number!`);
    return NaN;
  }
  const fixedNum = round2(parseFloat(num));
  return fixedNum;
}

export { getCurrency, convertPrice, getCurrencyRate, formatAgentWalletAmountIls };
